// useMaxProducts.js
import { useMemo } from "react";
import { BOM } from "@/types/general";

// Calculate the maximum number of products that can be produced
export const useMaxProducts = (components: BOM.Components.Component[]) => {
    return useMemo(() => {
        if (!components.length) return 0;

        const minProductsPerComponent = components.map(component => {
            const totalInStock = component.product.in_stock;
            return Math.max(0, Math.floor(totalInStock / component.quantity));
        });

        return Math.min(...minProductsPerComponent);
    }, [components]);
};
